import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';

// Shows the uploaded ad picture the way it is stored (base64) with its main details.
// `ad` is the raw ad document from the API (header, details, ad = base64 image, adType, dates...).
const imageSrc = (raw) => {
  if (!raw) return '';
  const s = String(raw);
  return s.startsWith('data:') ? s : `data:image/jpeg;base64,${s}`;
};

const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-GB') : 'N/A');

const AdPreviewDialog = ({ ad, onClose }) => (
  <Dialog open={!!ad} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ fontWeight: 700 }}>Ad Preview{ad && ad.header ? ` – ${ad.header}` : ''}</DialogTitle>
    <DialogContent dividers>
      {ad && (
        <Box>
          {ad.ad ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', bgcolor: '#f1f5f9', borderRadius: 1, p: 1, mb: 2 }}>
              <img
                src={imageSrc(ad.ad)}
                alt={ad.header || 'Ad'}
                style={{ maxWidth: '100%', maxHeight: '60vh', objectFit: 'contain' }}
              />
            </Box>
          ) : (
            <Typography color="text.secondary" sx={{ mb: 2 }}>No image was uploaded for this ad.</Typography>
          )}
          <Typography variant="body2"><strong>Type:</strong> {String(ad.adType || 'N/A').toUpperCase()}</Typography>
          <Typography variant="body2"><strong>Details:</strong> {ad.details || 'N/A'}</Typography>
          <Typography variant="body2"><strong>Campaign:</strong> {fmt(ad.startDate)} – {fmt(ad.endDate)}</Typography>
          {ad.timeSlot ? <Typography variant="body2"><strong>Time slot:</strong> {ad.timeSlot} s</Typography> : null}
        </Box>
      )}
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
  </Dialog>
);

export default AdPreviewDialog;
